export default {
    baseStyle: {
        title: {
            fontWeight: '500',
            lineHeight: 'normal',
            fontSize: {base: '32px', md: '24px', '2xl': '32px'},
            letterSpacing: {base: '0.16px', md: '0.12px', xl: '0.16px'}
        },
        subheadText: (isSmallText) => ({
            fontWeight: '300',
            fontSize: isSmallText ? '14px' : '17px',
            lineHeight: isSmallText ? '22px' : '26px',
            letterSpacing: isSmallText ? '0.085px' : '0.07px'
        })
    },
    variants: {
        yr: {},
        ks: {
            title: {
                fontFamily: 'heading',
                fontSize: '32px',
                letterSpacing: '0.16px'
            },
            subheadText: (subheadTextFontFamily) => ({
                fontSize: {
                    base: subheadTextFontFamily === 'heading' ? '23px' : '14px',
                    lg: subheadTextFontFamily === 'heading' ? '23px' : '17px',
                    'xl-large': subheadTextFontFamily === 'heading' ? '23px' : '16px'
                },
                lineHeight: {
                    base: subheadTextFontFamily === 'heading' ? 'normal' : '22px',
                    lg: subheadTextFontFamily === 'heading' ? 'normal' : '26px',
                    'xl-large': subheadTextFontFamily === 'heading' ? 'normal' : '35px'
                },
                letterSpacing: {
                    base: subheadTextFontFamily === 'heading' ? '0.115px' : '0.07px',
                    lg: subheadTextFontFamily === 'heading' ? '0.115px' : '0.085px',
                    'xl-large': subheadTextFontFamily === 'heading' ? '0.115px' : '0.08px'
                }
            })
        }
    },
    parts: ['title', 'subheadText'],
    defaultProps: {
        variant: 'yr'
    }
}
